(function () {'use strict';}());
angular.module("app").directive('shareView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'views/share.html?version=1.0',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
      }  
    };
  });